export var DeliveryMethod;
(function (DeliveryMethod) {
    DeliveryMethod["NO_DELIVERY"] = "NO_DELIVERY";
    DeliveryMethod["ADDRESS_BILLING"] = "ADDRESS_BILLING";
    DeliveryMethod["ADDRESS_ON_FILE"] = "ADDRESS_ON_FILE";
    DeliveryMethod["ADDRESS_OTHER"] = "ADDRESS_OTHER";
    DeliveryMethod["PICKUP"] = "PICKUP";
    DeliveryMethod["ELECTRONIC"] = "ELECTRONIC";
})(DeliveryMethod || (DeliveryMethod = {}));
//# sourceMappingURL=DeliveryMethod.js.map